import { computed, defineComponent, onMounted, watch } from '@vue/composition-api';
import ListDropdown from '@/uikit/ListDropdown.vue';
export default defineComponent({
    components: {
        ListDropdown
    },
    props: {
        questions: {
            type: Array,
            default: () => []
        },
        // The heading was hard-coded to 'FAQ'. Keeping that as the default means
        // no caller has to pass anything, and the geo pages can label their own.
        title: {
            type: String,
            default: 'FAQ'
        }
    },
    setup(props, context) {
        const { emit } = context;
        const structuredDataFAQ = computed(() => {
            return {
                '@type': 'FAQPage',
                mainEntity: props.questions.map((question) => ({
                    '@type': 'Question',
                    name: question.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: question.answer
                    }
                }))
            };
        });
        watch(() => props.questions, () => {
            emit('structured-data-ready', structuredDataFAQ.value);
        });
        onMounted(() => {
            emit('structured-data-ready', structuredDataFAQ.value);
        });
        return {};
    }
});
